import { FormattedMessage } from 'react-intl';
import { Tabs, TabsContent, TabsList, TabsTrigger } from 'src/registry/ui/Tabs';
import MoneyAccountsTable from 'src/features/moneyAccounts/components/tables/MoneyAccountsTable';
import { moneyAccountsMessages } from 'src/features/moneyAccounts/utils/messages';
import { bankAccountMessages } from 'src/features/billingEntityBankAccounts/utils/messages';
import BillingEntityBankAccountsTable from 'src/features/billingEntityBankAccounts/components/tables/BillingEntityBankAccountsTable';
import useHasPermissions from 'src/utils/useHasPermissions';
import { PERMISSION } from 'src/features/auth/types';

const BillingEntityDashboardTables = () => {
    const permissionAccessMoneyAccounts = useHasPermissions([PERMISSION.ACCESS_MONEY_ACCOUNTS]);

    const defaultTabValue = (() => {
        if (permissionAccessMoneyAccounts) return 'money-accounts';
        return 'bank-accounts';
    })();
    return (
        <div className="grid flex-3 grid-cols-1 pr-8">
            <Tabs defaultValue={defaultTabValue}>
                <TabsList>
                    {permissionAccessMoneyAccounts && (
                        <TabsTrigger value="money-accounts">
                            <FormattedMessage {...moneyAccountsMessages.moneyAccounts} />
                        </TabsTrigger>
                    )}

                    <TabsTrigger value="bank-accounts">
                        <FormattedMessage {...bankAccountMessages.bankAccounts} />
                    </TabsTrigger>
                </TabsList>
                {permissionAccessMoneyAccounts && (
                    <TabsContent value="money-accounts">
                        <MoneyAccountsTable />
                    </TabsContent>
                )}
                <TabsContent value="bank-accounts">
                    <BillingEntityBankAccountsTable />
                </TabsContent>
            </Tabs>
        </div>
    );
};

export default BillingEntityDashboardTables;
